import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { axiosInstance } from '../..';
import { TWithdrawFundsProps } from '../../../types';

export const withdrawFunds = createAsyncThunk<null, TWithdrawFundsProps>('withdrawals/withdraw', async (props, { rejectWithValue }) => {
  try {
    await axiosInstance.post('/withdrawals', props);

    return null;
  } catch (error) {
    const err = error as AxiosError;
    return rejectWithValue(err);
  }
});
